
class CapViewRouteMap {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_route_map'
}

function create(config) {
  return new CapViewRouteMap(config)
}

export default {
  key,
  create,
}
